"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TabPanel = _ref => {
  let {
    children,
    index,
    value
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", null, value === index && /*#__PURE__*/_react.default.createElement("div", null, children));
};
exports.TabPanel = TabPanel;
TabPanel.propTypes = {
  children: _propTypes.default.node.isRequired,
  value: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired
};
var _default = exports.default = TabPanel;